import React, { useState } from "react";

// A small ⓘ that explains the thing next to it. Hover to peek, click to keep
// it open. Clicks don't reach the parent (e.g. a sortable table header).
const InfoTip = ({ title, text, align = "left" }) => {
  const [pinned, setPinned] = useState(false);
  return (
    <span className="relative inline-block group align-middle font-normal normal-case tracking-normal">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setPinned((p) => !p);
        }}
        aria-label={title ? `What is ${title}?` : "More info"}
        className="w-4 h-4 ml-1 rounded-full text-[10px] font-bold leading-4 text-center border border-blue-400 text-blue-600 hover:bg-blue-50"
      >
        i
      </button>
      <span
        className={`${pinned ? "block" : "hidden group-hover:block"} absolute z-30 top-5 ${
          align === "right" ? "right-0" : "left-0"
        } w-72 p-3 rounded-lg border bg-white shadow-lg text-left font-sans text-xs text-gray-700 whitespace-normal`}
      >
        {title && <span className="block font-semibold text-gray-900 mb-1">{title}</span>}
        <span className="block leading-relaxed">{text}</span>
      </span>
    </span>
  );
};

export default InfoTip;
